var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitor"},[_c('div',{staticClass:"overflow"},[_c('ul',_vm._l((_vm.log),function(m){return _c('li',[_vm._v("["+_vm._s(m.typeDesc)+"] "+_vm._s(m.message))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }